export default {
      id: "sort-usage",
      viewBox: "0 0 18 12",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#sort-usage",
      toString: function () {
        return this.url;
      }
    }